/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPlaceholder32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.417 12.333c0-5.476 4.44-9.916 9.916-9.916 5.477 0 9.917 4.44 9.917 9.916 0 5.477-4.44 9.917-9.917 9.917-5.476 0-9.916-4.44-9.916-9.917zM12.333.917C6.028.917.917 6.028.917 12.333c0 6.306 5.111 11.417 11.416 11.417 6.306 0 11.417-5.111 11.417-11.417C23.75 6.028 18.639.917 12.333.917zm14.377 9.965l-.622-.419-.838 1.245.623.418a9.906 9.906 0 11-13.747 13.747l-.418-.623-1.245.837.419.623A11.404 11.404 0 1026.71 10.882z'
      />
    </svg>
  );
}

export default SvgPlaceholder32;
